export enum UserStatus {
    Active = 'active',
    Pending = 'pending',
    Suspended = 'suspended',
    Deleted = 'deleted',
    Invited = 'invited',
}
